import 'parsleyjs';

import BaseView from '../../base-view';

var configSet = false;

export default BaseView.extend({

	initialize: function() {
		if (!configSet) {
			this.setParsleyConfig();
		}

		this.addParsleyValidators();

		this.parsleyForm = this.$el.parsley( {
			errorsWrapper: '<ul class="form-validation"></ul>',
			errorTemplate: '<li class="form-validation__item"></li>',
			errorClass: 'is-invalid',
			successClass: 'is-valid',
			trigger: 'blur',
			excluded: 'input[type=button], input[type=submit], input[type=reset], input[type=hidden], :hidden'
		});

		this.parsleyForm.on('parsley:form:validated', this.onFormValidated.bind(this));
		this.parsleyForm.on('parsley:field:validated', this.onfieldValidated.bind(this));
	},

	/**
	 * Form validated handler
	 **/
	onFormValidated: function(formInstance) {
		// trigger event to let other views know if the form gets validated
		this.trigger('form:validated', formInstance);
	},

	/**
	 * Single field validated handler
	 **/
	onfieldValidated: function(field) {
		// trigger event to let other views know if a field gets validated
		this.trigger('form:field:validated', field);

		// TODO: check if this is still needed
		if (field.$element.is(':hidden')) {
			field.validationResult = true;
			return true;
		}
	},

	/**
	 * set the global parsley configuration
	 **/
	setParsleyConfig: function() {
		window.ParsleyConfig = {
			errorsWrapper: '<ul class="form-validation"></ul>',
			errorTemplate: '<li class="form-validation__item"></li>',
			errorClass: 'is-invalid',
			successClass: 'is-valid',
			trigger: 'blur',
			excluded: 'input[type=button], input[type=submit], input[type=reset], input[type=hidden], :hidden'
		};
	},

	/**
	 * Add custom validators to parsley
	 **/
	addParsleyValidators: function() {
		// window.ParsleyValidator
		// 	.addValidator('validtime', Utils.isValidTime, 32);
	}
});
